var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _dec5, _dec6, _dec7, _class2, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import CatalogFunctionJobTraits from "./CatalogFunctionJobTraits";
import WebProcessingServiceCatalogFunctionTraits from "./WebProcessingServiceCatalogFunctionTraits";
export let WPSParameterTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Input Identifier",
  description: "WPS input parameter identifier"
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Input Value",
  description: "WPS input parameter value"
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Input Type",
  description: "WPS input parameter type"
}), _class = class WPSParameterTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "inputIdentifier", _descriptor, this);
    _initializerDefineProperty(this, "inputValue", _descriptor2, this);
    _initializerDefineProperty(this, "inputType", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "inputIdentifier", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "inputValue", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "inputType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let WebProcessingServiceCatalogJobTraits = (_dec4 = objectArrayTrait({
  type: WPSParameterTraits,
  idProperty: "inputIdentifier",
  name: "Parameters",
  description: "Parameter names & values for this result item"
}), _dec5 = anyTrait({
  name: "WPS Response",
  description: "The WPS response object"
}), _dec6 = anyTrait({
  name: "Geojson features",
  description: "Geojson feature collection of input features."
}), _dec7 = primitiveTrait({
  type: "string",
  name: "WPS response URL",
  description: "WPS response URL"
}), _class2 = class WebProcessingServiceCatalogJobTraits extends mixTraits(CatalogFunctionJobTraits, WebProcessingServiceCatalogFunctionTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "wpsParameters", _descriptor4, this);
    _initializerDefineProperty(this, "wpsResponse", _descriptor5, this);
    _initializerDefineProperty(this, "geojsonFeatures", _descriptor6, this);
    _initializerDefineProperty(this, "wpsResponseUrl", _descriptor7, this);
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "wpsParameters", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "wpsResponse", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "geojsonFeatures", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "wpsResponseUrl", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { WebProcessingServiceCatalogJobTraits as default };